<template>
<dialog-component
  :title="this.title"
  :customClose="this.closeModal"
  hideModalButtons
>
  <div class="dialog-content">
    <div 
      v-if="!isLeadEmpty && !showSpinner"
      class="lead-source" 
    >
      <json :input="lead"></json>
    </div>

    <spinner v-if="showSpinner" />

    <div 
      v-if="isLeadEmpty && !showSpinner" 
      class="text-center no-data-label" 
    >
      <i>Nothing to show</i>
    </div>
  </div>
</dialog-component>
</template>

<script>
import { isEmpty } from 'lodash';
import DialogComponent from '@/components/Dialog';
import Spinner from '@/components/Spinner';
import json from '@/components/Json';
import LEAD_QUERY from '../graphql/Lead/Lead.gql';

export default {
  name: 'Lead',
  components: {
    DialogComponent,
    Spinner,
    json,
  },
  data() {
    const id =
      this.$route && this.$route.params && this.$route.params.id ? +this.$route.params.id : -1;

    return {
      id,
      lead: {},
      title: `Lead ID: ${id}`,
      showSpinner: 0,
    };
  },

  computed: {
    isLeadEmpty() {
      return isEmpty(this.lead);
    },
  },
  apollo: {
    lead: {
      query: LEAD_QUERY,
      loadingKey: 'showSpinner',
      variables() {
        return {
          id: this.id,
        };
      },
    },
  },
  methods: {
    closeModal() {
      this.$router.push({ name: 'Leads' });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-content {
  margin-top: 20px;
  position: relative;
}
.lead-source {
  max-height: 65vh;
  overflow: auto;
  background-color: #f5f5f5;
  padding: 10px;
  font-size: 13px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/modals/LeadModal.vue